import { FeatureFlag } from 'js/sign-components/common/feature-flag';
import React from 'react';

type Props = {
  LegacyComponent: React.ComponentType<any>;
  DigComponent: React.ComponentType<any>;
  [key: string]: any; // Additional dynamic props
};

const Vis2023FeatureFlagComponent: React.FC<Props> = ({
  LegacyComponent,
  DigComponent,
  props,
}) => {
  return (
    <>
      <FeatureFlag name="sign_core_2024_10_23_vis2023" value={false}>
        <LegacyComponent {...props} />
      </FeatureFlag>
      <FeatureFlag name="sign_core_2024_10_23_vis2023" value={true}>
        <DigComponent {...props} />
      </FeatureFlag>
    </>
  );
};

export default Vis2023FeatureFlagComponent;
